import { PureComponent, Fragment } from 'react';
import autoBind from 'react-autobind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp } from '@fortawesome/pro-regular-svg-icons/faAngleUp';
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons/faAngleDown';

import withComponentName from '../../../decorators/withComponentName';

import Styles from './styles.module.scss';

export class FAQComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
    autoBind(this);
  }

  toggleExpand(e) {
    const { id, setActiveFAQid } = this.props;

    e.stopPropagation();
    this.setState(({ expanded }) => ({
      expanded: !expanded,
    }), () => {
      const { expanded } = this.state;
      if (expanded) setActiveFAQid(id);
    });
  }

  cardContentInteraction(e) {
    this.toggleExpand(e);
  }

  render() {
    const { expanded } = this.state;
    const {
      id,
      question,
      answer,
      activeFAQid,
    } = this.props;

    return (
      <div className={Styles.faq} onClick={this.cardContentInteraction}>
        <div className={Styles.faq__content}>
          <div className={Styles.faq__content__details}>
            <span className={Styles.faq__question}>
              <span>•</span>{question}
            </span>
            <div className={expanded && activeFAQid === id ? `${Styles.faq__answer} ${Styles.show}` : `${Styles.faq__answer}`}>
              {answer.map((item, index) => (
                item instanceof Object ? (
                  item.className === 'note' ? (
                    <p key={index} className={Styles.note}>
                      {item.text}
                    </p>
                  ) : item.className === 'note_italic' ? (
                    <p key={index} className={Styles.note_italic}>
                      {item.text}
                    </p>
                  ) : item.className === 'italic' ? (
                    <span key={index} className={Styles.italic}>
                      {item.text}
                    </span>
                  ) : item.className === 'last' ? (
                    <Fragment key={index}>
                      <span className={Styles.text}>
                        {item.text}
                      </span>
                      <br />
                    </Fragment>
                  ) : (
                    <a
                      key={index}
                      href={item.href}
                      className={item.linkClassName ? Styles['inline-italic-link'] : undefined}
                    >
                      {item.text}
                    </a>
                  )
                ) : (
                  item
                )
              ))}
            </div>
          </div>
          <div className={Styles.faq__content__expand}>
            <span className={Styles.expand_btn} onClick={this.toggleExpand}>
              <FontAwesomeIcon
                className={`${Styles.img} ${Styles.desktop}`}
                icon={expanded && activeFAQid === id ? faAngleUp : faAngleDown}
              />
              <FontAwesomeIcon
                className={`${Styles.img} ${Styles.mob}`}
                icon={expanded && activeFAQid === id ? faAngleUp : faAngleDown}
              />
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default withComponentName(FAQComponent);
